var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-uni-view',{attrs:{"id":"mask"},on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
}}},[_c('v-uni-view',{attrs:{"id":"content"}},[_c('v-uni-view',{attrs:{"id":"title"}},[_vm._t("header",[_vm._v("温馨提示")])],2),_c('v-uni-view',{attrs:{"id":"body"}},[_vm._t("default",[_vm._v("默认遮罩内容")])],2),_c('v-uni-button',{staticClass:"footer",on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
}}},[_vm._t("footer",[_vm._v("确定")])],2)],1)],1):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }